import { PartInKit } from '@components/Product/Shared/PartsTab/PartInKit';
import { usePart } from '@services/part';

export default function KitsTab() {
  const part = usePart();
  const currentPart = part.current ?? part.partPath?.part;

  if (!currentPart) return null;

  return <PartInKit currentPart={currentPart} />;
}
